import React, { useContext } from 'react';
import { FaSpinner } from 'react-icons/fa';
import ThemeContext from '@theme/ThemeContext';
import { lightColors } from '@theme/colors';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: string;
  className?: string;
  text?: string;
  showText?: boolean;
  usePrimaryColor?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color,
  className = '',
  text,
  showText = false,
  usePrimaryColor = true
}) => {
  // Safely get theme context without throwing error
  const themeContext = useContext(ThemeContext);

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-2xl',
    xl: 'text-4xl'
  };

  // Use provided color, or theme primary, or default primary
  const spinnerColor = color || (usePrimaryColor && themeContext?.colors?.primary) || lightColors.primary;
  const spinnerStyle = { color: spinnerColor };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="flex items-center">
        <FaSpinner
          className={`animate-spin ${sizeClasses[size]}`}
          style={spinnerStyle}
        />
        {showText && text && (
          <span className="ml-2" style={spinnerStyle}>
            {text}
          </span>
        )}
      </div>
    </div>
  );
};

export default Spinner;
